<template>
    <div style="border: 1px solid #dcdfe6;width: 800px;">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            :style="{'height': height, 'overflow-y': 'hidden'}"
            v-model="htmls"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
            @onChange="onChange"
        />
    </div>
</template>

<script>
import { UPLOAD_PATH, UPLOAD_API } from '@/utils/constant.js';
import { get, post, postJson, upload } from '@/utils/request.js';
import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default Vue.extend({
    components: { Editor, Toolbar },
    props: {
        height:{
            type: String,
            default: '500px'
        }
    },
    data() {
        return {
            editor: null,
            htmls: null,
            toolbarConfig: { },
            editorConfig: {
                placeholder: '请输入内容...' ,
                MENU_CONF:{
                    uploadImage:{
                        fieldName: 'file',
                        server: UPLOAD_API + UPLOAD_PATH,
                        timeout: 5 * 1000,
                        metaWithUrl: true,
                        maxFileSize: 1000 * 1024 * 1024,
                        base64LimitSize: 0,
                        meta:{
                            token: localStorage.getItem('token')
                        },
                        async customUpload(files,insertFn){
                            var formData = new FormData();
                            formData.append("file", files, files.name);
                            await upload(UPLOAD_PATH,formData).then((da)=>{
                                if(da.success){
                                    insertFn(da.url)
                                }else {
                                    this.$message({
                                        message: da.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            })
                        }
                    },
                    uploadVideo:{
                        fieldName: 'file',
                        server: UPLOAD_API + "/mpp/file/upload",
                        timeout: 5 * 1000,
                        metaWithUrl: true,
                        base64LimitSize: 0,
                        meta:{
                            token: localStorage.getItem('token')
                        },
                        async customUpload(files,insertFn){
                            var formData = new FormData();
                            formData.append("file", files, files.name);
                            await upload("/mpp/file/upload",formData).then((da)=>{
                                if(da.success){
                                    insertFn(da.url)
                                }else {
                                    this.$message({
                                        message: da.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            })
                        }
                    },
                }
            },
            mode: 'default', // or 'simple'
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    methods: {
        init(val){
            this.htmls = null
            if (val == null || val === '') {
                this.htmls = ''
                return
            }
            val = val.replace(/&lt;/g, '<');
            val = val.replace(/&gt;/g, '>');
            val = val.replace(/&quot;/g, '"');
            val = val.replace(/&nbsp;/g, " ");
            val = val.replace(/&ldquo;/g, '"');
            val = val.replace(/&rdquo;/g, '"');
            val = val.replace(/&amp;nbsp;/g, ' ');
            val = val.replace(/&amp;ldquo;/g, '"');
            val = val.replace(/&amp;rdquo;/g, '"');
            // val = val.replace(//)
            console.log("val111111111111111",val)
            this.htmls = val
        },
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错

            // 上传配置项
            let result = this.editor.getMenuConfig('uploadImage')
        },
        onChange(editor){
            let html = editor.getHtml()
            const imgRegex = /<img[^>]*>/g;
            const matches = html.match(imgRegex);

            if (matches) {
                matches.forEach((imgTag) => {
                    // 正则表达式匹配 style 属性
                    const styleRegex = /style="([^"]*)"/;
                    const styleMatch = imgTag.match(styleRegex);

                    if (styleMatch) {
                        const styleAttr = styleMatch[0];
                        const styleValue = styleMatch[1];

                        // 判断 style 属性是否为空
                        if (styleValue.trim() === '') {
                            // 替换空的 style 属性为 width: 100%
                            const newImgTag = imgTag.replace(styleRegex, `style="width: 100%;"`);
                            html = html.replace(imgTag, newImgTag);
                        }
                    } else {
                        // 如果没有 style 属性，添加 style="width: 100%"
                        const newImgTag = imgTag.replace(/(<img[^>]*)>/, '$1 style="width: 100%;">');
                        html = html.replace(imgTag, newImgTag);
                    }
                });
            }

            this.$emit('change', html);
        },

    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    },
})
</script>

<style src="@wangeditor/editor/dist/css/style.css">

</style>
